import { PaintCollectionDisplay } from "@omni/types/components/paintConfigurator/enums/paintCollectionDisplay.enum";
import { cn } from "@omni/utils/styles";

import { useCollection } from "@/components/PaintConfigurator/context/paintConfigurator.context";

export const ColorListSkeleton = () => {
    const { collection } = useCollection();

    const display = collection?.display ?? PaintCollectionDisplay.List;

    return (
        <>
            {Array.from({ length: 20 }).map((_, index) => (
                <div
                    key={index}
                    className={cn(
                        "tw:w-full tw:bg-grey tw:rounded-sm tw:aspect-square tw:relative"
                    )}
                >
                    {index === 0 && (
                        <div
                            className={cn(
                                "tw:absolute tw:left-0 tw:w-30 tw:h-6 tw:rounded-sm tw:bg-grey",
                                {
                                    "tw:-top-8": display === "list"
                                }
                            )}
                        />
                    )}
                </div>
            ))}
        </>
    );
};
